import { Address } from 'viem';
import {
  arbitrum,
  base,
  bsc,
  bscTestnet,
  mainnet,
  polygon,
} from 'wagmi/chains';

export const USDT_ADDRESSES: Record<number, Address> = {
  [bsc.id]: '0x55d398326f99059fF775485246999027B3197955',
  [bscTestnet.id]: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
  [mainnet.id]: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  [arbitrum.id]: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
  [base.id]: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
  [polygon.id]: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
};

export const USDC_ADDRESSES: Record<number, Address> = {
  [bsc.id]: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
  [bscTestnet.id]: '0x64544969ed7EBf5f083679233325356EbE738930',
  [mainnet.id]: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  [arbitrum.id]: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  [base.id]: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  [polygon.id]: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
};

export const USDT_DATA = {
  [bsc.id]: {
    decimals: 18,
    symbol: 'USDT',
    name: 'Tether USD',
    contractAddress: USDT_ADDRESSES[bsc.id],
  },
  [bscTestnet.id]: {
    decimals: 18,
    symbol: 'USDT',
    name: 'Tether USD',
    contractAddress: USDT_ADDRESSES[bscTestnet.id],
  },
  [mainnet.id]: {
    decimals: 6,
    symbol: 'USDT',
    name: 'Tether USD',
    contractAddress: USDT_ADDRESSES[mainnet.id],
  },
  [arbitrum.id]: {
    decimals: 6,
    symbol: 'USDT',
    name: 'Tether USD',
    contractAddress: USDT_ADDRESSES[arbitrum.id],
  },
  [base.id]: {
    decimals: 6,
    symbol: 'USDT',
    name: 'Tether USD',
    contractAddress: USDT_ADDRESSES[base.id],
  },
  [polygon.id]: {
    decimals: 6,
    symbol: 'USDT',
    name: 'Tether USD',
    contractAddress: USDT_ADDRESSES[polygon.id],
  },
};

export const USDC_DATA = {
  [bsc.id]: {
    decimals: 18,
    symbol: 'USDC',
    name: 'USD Coin',
    contractAddress: USDC_ADDRESSES[bsc.id],
  },
  [bscTestnet.id]: {
    decimals: 18,
    symbol: 'USDC',
    name: 'USD Coin',
    contractAddress: USDC_ADDRESSES[bscTestnet.id],
  },
  [mainnet.id]: {
    decimals: 6,
    symbol: 'USDC',
    name: 'USD Coin',
    contractAddress: USDC_ADDRESSES[mainnet.id],
  },
  [arbitrum.id]: {
    decimals: 6,
    symbol: 'USDC',
    name: 'USD Coin',
    contractAddress: USDC_ADDRESSES[arbitrum.id],
  },
  [base.id]: {
    decimals: 6,
    symbol: 'USDC',
    name: 'USD Coin',
    contractAddress: USDC_ADDRESSES[base.id],
  },
  [polygon.id]: {
    decimals: 6,
    symbol: 'USDC',
    name: 'USD Coin',
    contractAddress: USDC_ADDRESSES[polygon.id],
  },
};

export const BASIC_TRANSFER_TOKEN_FUNCTIONS = [
  'function approve(address,uint)',
  'function transfer(address to, uint256 amount) external returns (bool)',
] as const;
